const selectors = {
  filters: "[data-filters]",
  select: "[data-select]",
};

const initFilters = (filters) => {
  const selectList = filters.querySelectorAll(selectors.select);

  selectList.forEach((select) => {
    select.firstElementChild.addEventListener("change", () => filters.submit());
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const filtersList = document.querySelectorAll(selectors.filters);

    filtersList?.forEach(initFilters);
  },
  {
    once: true,
  }
);
